import { Validators } from '@angular/forms';

const alphanumericRegex = /^[a-zA-Z0-9]*$/;
export const AlphanumericValidator = Validators.pattern(alphanumericRegex);
